import React from "react"
import { Button, Modal, Spinner } from "react-bootstrap"

type ModalViewProps = {
  title: string
  show: boolean
  disableButton?: boolean
  isCenter?: boolean
  buttonTitle: string
  buttonLoader: boolean
  onHideModal: () => void
  onButtonClick: () => void
  children?: React.ReactNode
  noFooter?: boolean
}

export const ModalView: React.FC<ModalViewProps> = ({
  title,
  show,
  disableButton,
  isCenter,
  buttonTitle,
  buttonLoader,
  children,
  onHideModal,
  onButtonClick,
  noFooter,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHideModal}
      size={isCenter ? "lg" : null}
      aria-labelledby="contained-modal-title-vcenter"
      centered={isCenter}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body> {children} </Modal.Body>
      {!noFooter && (
        <Modal.Footer>
          <Button
            disabled={disableButton ? disableButton : buttonLoader}
            variant="primary"
            onClick={!buttonLoader ? onButtonClick : null}
          >
            {buttonLoader ? <Spinner animation="border" size="sm" /> : buttonTitle}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  )
}
